import React, { FC, memo } from 'react';
import { BoxProps } from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { Bedrooms, Card, From, Price } from './filter.styles';
import { withLocaleString } from '@keaze/web/utils/withLocaleString';

type CustomProps = {
  price: number;
  bedroom: string;
  checked: boolean;
  onClick: () => void;
};

type Props = BoxProps & CustomProps;

type GeneratePrice = (price: number) => JSX.Element | string;

const generatePrice: GeneratePrice = (price) => {
  if (price === -1) {
    return 'TBD';
  }

  return <>&#163;{withLocaleString(price)}</>;
};

export const Filter: FC<Props> = memo(
  ({ checked = false, price, bedroom, onClick, ...rest }) => (
    <Card {...rest} $checked={checked} onClick={onClick}>
      <From variant="body2">From</From>
      <Price variant="body1">{generatePrice(price)}</Price>
      <Bedrooms variant="body2">{bedroom}</Bedrooms>
    </Card>
  )
);
